import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type AdminOrgScope = 'all' | 'company';

const STORAGE_KEY = 'wa-admin-org-scope';

/**
 * Super admins can work in "All organizations" mode (cross-company queues)
 * or a normal single-company mode.
 */
@Injectable({ providedIn: 'root' })
export class AdminScopeService {
  private readonly scopeSubject = new BehaviorSubject<AdminOrgScope>(
    this.readStored()
  );

  readonly scope$: Observable<AdminOrgScope> = this.scopeSubject.asObservable();

  get scope(): AdminOrgScope {
    return this.scopeSubject.value;
  }

  get isAllOrganizations(): boolean {
    return this.scopeSubject.value === 'all';
  }

  setScope(scope: AdminOrgScope): void {
    try {
      localStorage.setItem(STORAGE_KEY, scope);
    } catch {
      /* ignore */
    }
    this.scopeSubject.next(scope);
  }

  clear(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
    this.scopeSubject.next('company');
  }

  private readStored(): AdminOrgScope {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw === 'all' ? 'all' : 'company';
    } catch {
      return 'company';
    }
  }
}
